import PaginatedList from '@theme/paginated-list';

/**
 * A custom element that renders a paginated insights grid list
 */
export default class InsightsGridList extends PaginatedList {}

if (!customElements.get('insights-grid-list')) {
  customElements.define('insights-grid-list', InsightsGridList);
}
